import type { BreakdownSingleDataSet } from '../../../../DataProvider/types';
import type { DataConverter, SheetData } from '../types';
import { formatColumnName } from './utils';

/**
 * Convert BreakdownSingleDataSet to sheet format
 * Used for grouped bar charts and stacked bar charts
 */
export const convertBreakdownSingleDataToSheet: DataConverter<
  BreakdownSingleDataSet
> = ({ data, primaryDimension, secondaryDimension }): SheetData[] => {
  const formattedPrimaryDimension = formatColumnName(primaryDimension);
  const formattedSecondaryDimension = formatColumnName(secondaryDimension);

  const primaryEntities = Array.from(
    new Set(data.data.map((breakdown) => breakdown.dim))
  );
  const secondaryEntities = Array.from(
    new Set(
      data.data.flatMap((breakdown) =>
        breakdown.breakdown.map((item) => item.dim)
      )
    )
  );

  const headerRow1: SheetData = {
    [formattedSecondaryDimension]: formattedPrimaryDimension,
  };
  const headerRow2: SheetData = {
    [formattedSecondaryDimension]: formattedSecondaryDimension,
  };

  primaryEntities.forEach((primaryEntity) => {
    const formattedPrimaryEntity = formatColumnName(primaryEntity);
    headerRow1[`${formattedPrimaryEntity} Count`] = formattedPrimaryEntity;
    headerRow1[`${formattedPrimaryEntity} Share`] = '';
    headerRow2[`${formattedPrimaryEntity} Count`] = 'Count';
    headerRow2[`${formattedPrimaryEntity} Share`] = 'Share';
  });

  const dataRows = secondaryEntities.map((secondaryEntity) => {
    const row: SheetData = {
      [formattedSecondaryDimension]: secondaryEntity,
    };

    primaryEntities.forEach((primaryEntity) => {
      const primaryData = data.data.find(
        (breakdown) => breakdown.dim === primaryEntity
      );
      const item = primaryData?.breakdown.find(
        (item) => item.dim === secondaryEntity
      );

      const formattedPrimaryEntity = formatColumnName(primaryEntity);
      row[`${formattedPrimaryEntity} Count`] = item?.value ?? 0;
      row[`${formattedPrimaryEntity} Share`] = item?.share ?? 0;
    });

    return row;
  });

  return [headerRow1, headerRow2, ...dataRows];
};
